import { ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'

export default function EmbeddedVideo({
  videoSrc,
  videoTitle,
  sxx,
}: {
  videoTitle?: string
  videoSrc: string
  sxx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',

        width: '100%',
        ...sxx,
      }}
    >
      {videoTitle && (
        <Text
          as="h2"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: ['2.4rem', '2.8rem', '2.8rem'],
            mb: 'default',
          }}
        >
          {videoTitle}
        </Text>
      )}
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          border: ({ colors }) => `2px solid ${colors?.white25}`,
          borderRadius: '1.6rem',
        }}
      >
        <EmbeddedVideoIframe videoSrc={videoSrc} videoTitle={videoTitle} />
      </Flex>
    </Flex>
  )
}

export function EmbeddedVideoIframe({
  videoSrc,
  videoTitle,
}: {
  videoSrc: string
  videoTitle?: string
}): ReactElement {
  return (
    <iframe
      sx={{
        aspectRatio: '16 / 9',
        width: '100%',
        border: 0,
        borderRadius: '1.6rem',
      }}
      src={videoSrc}
      title={videoTitle}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  )
}
